<div class="flex flex-col h-full bg-[#fcfdfe] border-r border-gray-200 transition-all duration-200 ease-in-out" [style.width]="isCollapsed ? '4rem' : '13.5rem'">
  <!-- Logo Section -->
  <div class="h-16 flex items-center border-b border-gray-200 overflow-hidden transition-all duration-200 ease-in-out" 
       [class.justify-center]="isCollapsed" 
       [class.px-4]="!isCollapsed"
       [class.px-0]="isCollapsed">
    <div class="flex items-center justify-center transition-all duration-200"
         [class.-ml-3]="!isCollapsed"
         [class.ml-0]="isCollapsed">
      <img src="/AngulerisLogo.png" alt="Logo" class="h-14 w-14 object-contain">
    </div>
    <span class="font-bold text-lg text-[#2e384d] truncate transition-all duration-200 whitespace-nowrap overflow-hidden"
          [class.opacity-0]="isCollapsed"
          [class.w-0]="isCollapsed"
          [class.ml-0]="isCollapsed"
          [class.ml-[-8px]]="!isCollapsed">
      anguleris<sup class="text-[0.6rem] font-normal align-super ml-0.5 select-none">®</sup>
    </span>
  </div>

  <!-- Navigation Links -->
  <div class="flex-1 overflow-y-auto py-4 px-3 space-y-6 scrollbar-none">
    
    <!-- PLUGINS Section -->
    <div class="space-y-1">
      <div class="text-xs font-semibold text-gray-600 uppercase tracking-wider transition-all duration-200 overflow-hidden whitespace-nowrap"
           [class.opacity-0]="isCollapsed"
           [class.h-0]="isCollapsed"
           [class.px-3]="!isCollapsed"
           [class.px-0]="isCollapsed">
        Plugins
      </div>
      <div class="space-y-1 mt-2">
        <a routerLink="/download" routerLinkActive="bg-gray-100 text-blue-600 font-semibold" 
           class="flex items-center py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 rounded-lg transition-all duration-200 ease-in-out cursor-pointer no-underline overflow-hidden whitespace-nowrap"
           [class.justify-center]="isCollapsed"
           [class.px-3]="!isCollapsed"
           [class.px-0]="isCollapsed"
           [class.gap-3]="!isCollapsed"
           [class.gap-0]="isCollapsed">
          <i class="pi pi-download text-lg min-w-[1.25rem] text-center"></i>
          <span class="text-sm transition-all duration-200 overflow-hidden"
                [class.opacity-0]="isCollapsed"
                [class.w-0]="isCollapsed"
                [class.pointer-events-none]="isCollapsed">
            Download
          </span>
        </a>
        <a routerLink="/plugins/releases" routerLinkActive="bg-gray-100 text-blue-600 font-semibold" 
           class="flex items-center py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 rounded-lg transition-all duration-200 ease-in-out cursor-pointer no-underline overflow-hidden whitespace-nowrap"
           [class.justify-center]="isCollapsed"
           [class.px-3]="!isCollapsed"
           [class.px-0]="isCollapsed"
           [class.gap-3]="!isCollapsed"
           [class.gap-0]="isCollapsed">
          <i class="pi pi-upload text-lg min-w-[1.25rem] text-center"></i>
          <span class="text-sm transition-all duration-200 overflow-hidden"
                [class.opacity-0]="isCollapsed"
                [class.w-0]="isCollapsed"
                [class.pointer-events-none]="isCollapsed">
            Releases
          </span>
        </a>
        @if (isAdmin) {
          <a routerLink="/plugins/permissions" routerLinkActive="bg-gray-100 text-blue-600 font-semibold" 
             class="flex items-center py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 rounded-lg transition-all duration-200 ease-in-out cursor-pointer no-underline overflow-hidden whitespace-nowrap"
             [class.justify-center]="isCollapsed"
             [class.px-3]="!isCollapsed"
             [class.px-0]="isCollapsed"
             [class.gap-3]="!isCollapsed"
             [class.gap-0]="isCollapsed">
            <i class="pi pi-shield text-lg min-w-[1.25rem] text-center"></i>
            <span class="text-sm transition-all duration-200 overflow-hidden"
                  [class.opacity-0]="isCollapsed"
                  [class.w-0]="isCollapsed"
                  [class.pointer-events-none]="isCollapsed">
              Permissions
            </span>
          </a>
        }
        @if (canViewTelemetry) {
          <a routerLink="/plugins/telemetry" routerLinkActive="bg-gray-100 text-blue-600 font-semibold" 
             class="flex items-center py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 rounded-lg transition-all duration-200 ease-in-out cursor-pointer no-underline overflow-hidden whitespace-nowrap"
             [class.justify-center]="isCollapsed"
             [class.px-3]="!isCollapsed"
             [class.px-0]="isCollapsed"
             [class.gap-3]="!isCollapsed"
             [class.gap-0]="isCollapsed">
            <i class="pi pi-chart-line text-lg min-w-[1.25rem] text-center"></i>
            <span class="text-sm transition-all duration-200 overflow-hidden"
                  [class.opacity-0]="isCollapsed"
                  [class.w-0]="isCollapsed"
                  [class.pointer-events-none]="isCollapsed">
              Telemetry
            </span>
          </a>
        }
        @if (canViewTelemetry) {
          <a routerLink="/plugins/qa-profiles" routerLinkActive="bg-gray-100 text-blue-600 font-semibold" 
             class="flex items-center py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 rounded-lg transition-all duration-200 ease-in-out cursor-pointer no-underline overflow-hidden whitespace-nowrap"
             [class.justify-center]="isCollapsed"
             [class.px-3]="!isCollapsed"
             [class.px-0]="isCollapsed"
             [class.gap-3]="!isCollapsed"
             [class.gap-0]="isCollapsed">
            <i class="pi pi-check-square text-lg min-w-[1.25rem] text-center"></i>
            <span class="text-sm transition-all duration-200 overflow-hidden"
                  [class.opacity-0]="isCollapsed"
                  [class.w-0]="isCollapsed"
                  [class.pointer-events-none]="isCollapsed">
              QA Profiles
            </span>
          </a>
          <a routerLink="/plugins/qa-dictionaries" routerLinkActive="bg-gray-100 text-blue-600 font-semibold" 
             class="flex items-center py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 rounded-lg transition-all duration-200 ease-in-out cursor-pointer no-underline overflow-hidden whitespace-nowrap"
             [class.justify-center]="isCollapsed"
             [class.px-3]="!isCollapsed"
             [class.px-0]="isCollapsed"
             [class.gap-3]="!isCollapsed"
             [class.gap-0]="isCollapsed">
            <i class="pi pi-book text-lg min-w-[1.25rem] text-center"></i>
            <span class="text-sm transition-all duration-200 overflow-hidden"
                  [class.opacity-0]="isCollapsed"
                  [class.w-0]="isCollapsed"
                  [class.pointer-events-none]="isCollapsed">
              QA Dictionaries
            </span>
          </a>
          <a routerLink="/plugins/qa-reports" routerLinkActive="bg-gray-100 text-blue-600 font-semibold" 
             class="flex items-center py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 rounded-lg transition-all duration-200 ease-in-out cursor-pointer no-underline overflow-hidden whitespace-nowrap"
             [class.justify-center]="isCollapsed"
             [class.px-3]="!isCollapsed"
             [class.px-0]="isCollapsed"
             [class.gap-3]="!isCollapsed"
             [class.gap-0]="isCollapsed">
            <i class="pi pi-chart-bar text-lg min-w-[1.25rem] text-center"></i>
            <span class="text-sm transition-all duration-200 overflow-hidden"
                  [class.opacity-0]="isCollapsed"
                  [class.w-0]="isCollapsed"
                  [class.pointer-events-none]="isCollapsed">
              QA Reports
            </span>
          </a>
          <a routerLink="/plugins/feedback" routerLinkActive="bg-gray-100 text-blue-600 font-semibold" 
             class="flex items-center py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 rounded-lg transition-all duration-200 ease-in-out cursor-pointer no-underline overflow-hidden whitespace-nowrap"
             [class.justify-center]="isCollapsed"
             [class.px-3]="!isCollapsed"
             [class.px-0]="isCollapsed"
             [class.gap-3]="!isCollapsed"
             [class.gap-0]="isCollapsed">
            <i class="pi pi-comments text-lg min-w-[1.25rem] text-center"></i>
            <span class="text-sm transition-all duration-200 overflow-hidden"
                  [class.opacity-0]="isCollapsed"
                  [class.w-0]="isCollapsed"
                  [class.pointer-events-none]="isCollapsed">
              Feedback
            </span>
          </a>
        }
      </div>
    </div>

    <!-- TEAM Section -->
    <div class="space-y-1">
      <div class="text-xs font-semibold text-gray-600 uppercase tracking-wider transition-all duration-200 overflow-hidden whitespace-nowrap"
           [class.opacity-0]="isCollapsed"
           [class.h-0]="isCollapsed"
           [class.px-3]="!isCollapsed"
           [class.px-0]="isCollapsed">
        Team
      </div>
      <div class="space-y-1 mt-2">
        <a routerLink="/team-management/employees" routerLinkActive="bg-gray-100 text-blue-600 font-semibold" 
           class="flex items-center py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 rounded-lg transition-all duration-200 ease-in-out cursor-pointer no-underline overflow-hidden whitespace-nowrap"
           [class.justify-center]="isCollapsed"
           [class.px-3]="!isCollapsed"
           [class.px-0]="isCollapsed"
           [class.gap-3]="!isCollapsed"
           [class.gap-0]="isCollapsed">
          <i class="pi pi-users text-lg min-w-[1.25rem] text-center"></i>
          <span class="text-sm transition-all duration-200 overflow-hidden"
                [class.opacity-0]="isCollapsed"
                [class.w-0]="isCollapsed"
                [class.pointer-events-none]="isCollapsed">
            Employees
          </span>
        </a>
      </div>
    </div>

  </div>

  <!-- Bottom Toggle Button -->
  <div class="p-3 border-t border-gray-200">
    <button (click)="onToggleCollapse()" class="w-full flex items-center justify-center p-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-900 border-none bg-transparent cursor-pointer">
      <i class="pi" [class.pi-angle-double-left]="!isCollapsed" [class.pi-angle-double-right]="isCollapsed" style="font-size: 1.2rem;"></i>
    </button>
  </div>
</div>
